import PropTypes from 'prop-types'
import React from 'react'
import SelectField from '../../molecules/fields/SelectField'
import {
  getLabel,
  getQuestionsPreviousSteps,
  questionTypesGroupInclude
} from '../../../configs/questionTypesAdminConfig'
import * as validations from '../../../utils/validations'
import { getIndexSubtype } from '../../../configs/questionTypesCitizenConfig'

export const FilterQuestion = ({ steps }) => {
  const getFilterQuestionOptions = () => {
    const filterQuestionOptions = []
    steps.forEach((step, stepIndex) => {
      const questions = step.questions_attributes
      const questionsPreviousSteps = getQuestionsPreviousSteps(steps, stepIndex)
      questions.forEach((question, index) => {
        if (questionTypesGroupInclude('general', question.kind) && !question._destroy && question.manual_request) {
          const position = getIndexSubtype({ questionsPreviousSteps, questions, index })
          const label = `${position}. ${getLabel(question)}`
          filterQuestionOptions.push({ value: question.key, label })
        }
      })
    })
    return filterQuestionOptions
  }

  return (
    <SelectField
      name="filter_question"
      options={getFilterQuestionOptions()}
      containerClassName="mt-2"
      defaultSelection="Selecciona una pregunta"
      validate={validations.required()}
    />
  )
}

FilterQuestion.propTypes = {
  steps: PropTypes.array.isRequired
}
